/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Assets {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Request a presigned URL for direct client upload to S3. This is step 1 of the upload flow: 1. Client calls this endpoint with file metadata 2. Backend creates PENDING asset record 3. Backend generates presigned POST URL 4. Client uploads file directly to S3 using returned URL 5. Client calls /assets/{id}/confirm to mark upload complete The presigned URL expires in 15 minutes.
   *
   * @tags Assets
   * @name RequestUploadUrl
   * @summary Request Upload Url
   * @request POST:/api/assets/upload-url
   * @secure
   */
  requestUploadUrl = (data, params = {}) =>
    this.http.request({
      path: `/api/assets/upload-url`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Confirm that file upload completed successfully. This is step 2 (final) of the upload flow. Call this after successfully uploading the file to S3 using the presigned URL. The backend will: 1. Verify the file exists in S3 2. Update asset status to COMPLETED 3. Record actual file size
   *
   * @tags Assets
   * @name ConfirmUpload
   * @summary Confirm Upload
   * @request POST:/api/assets/{asset_id}/confirm
   * @secure
   */
  confirmUpload = (assetId, data, params = {}) =>
    this.http.request({
      path: `/api/assets/${assetId}/confirm`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get asset metadata by ID.
   *
   * @tags Assets
   * @name GetAsset
   * @summary Get Asset
   * @request GET:/api/assets/{asset_id}
   * @secure
   */
  getAsset = (assetId, params = {}) =>
    this.http.request({
      path: `/api/assets/${assetId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update asset metadata (tags, metadata, description, entity associations).
   *
   * @tags Assets
   * @name UpdateAsset
   * @summary Update Asset
   * @request PATCH:/api/assets/{asset_id}
   * @secure
   */
  updateAsset = (assetId, data, params = {}) =>
    this.http.request({
      path: `/api/assets/${assetId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an asset and its file from storage.
   *
   * @tags Assets
   * @name DeleteAsset
   * @summary Delete Asset
   * @request DELETE:/api/assets/{asset_id}
   * @secure
   */
  deleteAsset = (assetId, params = {}) =>
    this.http.request({
      path: `/api/assets/${assetId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Generate a presigned download URL for an asset. The URL is valid for the specified expiration time (default 1 hour, max 7 days). Downloads are tracked in the asset's download count.
   *
   * @tags Assets
   * @name GetDownloadUrl
   * @summary Get Download Url
   * @request GET:/api/assets/{asset_id}/download-url
   * @secure
   */
  getDownloadUrl = (assetId, query, params = {}) =>
    this.http.request({
      path: `/api/assets/${assetId}/download-url`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List assets with optional filters. Supports filtering by: - Entity type and ID (e.g., application, maintenance_request) - Upload status (pending, completed, etc.) - Tags (module and category) - Pagination (limit and offset)
   *
   * @tags Assets
   * @name ListAssets
   * @summary List Assets
   * @request GET:/api/assets
   * @secure
   */
  listAssets = (query, params = {}) =>
    this.http.request({
      path: `/api/assets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
